import { Field, Model } from 'serialize-ts';
import { BaseHttpError } from './base-http-error.model';

@Model()
export class GeneralHttpError extends BaseHttpError {
  @Field()
  message?: string;
}
